import { fuzzySearchFoodItems } from './SearchItem';

export function handleSearchFoodItems(
    products: any,
    query: string
  ): any {
    if (!query) return [];
  
    // Your fuzzy logic here
    return fuzzySearchFoodItems(products, query);
  }
  